module.exports = __webpack_public_path__ + "img/2.7daf468e.png";